module.exports = __webpack_public_path__ + "aab047d0c2faa414f78f114bba6485cf.png";